import { HarvestTypes, VehicleTypeEnum } from "@gtpl/shared-models/common-models";
import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";

@Entity('rm_purchase_analysis', { schema: 'public' })
export class RMPurchaseAnalysisEntity{
    @PrimaryGeneratedColumn('increment', {name: 'id'})
    id: number;

    @Column('int', {
        nullable: false,
        name: "plant_id"
    })
    plantId: number;  

    @Column('int', {
        nullable: true,
        name: "sub_plant_id"
    })
    subPlantId: number;  

    @Column("varchar", {
        nullable: false,
        name: "lot_number",
        length: 50
    })
    lotNumber: string;

    @Column("int", {
        nullable: false,
        name: "grade"
    })
    grade: number;

    @Column("int", {
        nullable: false,
        name: "boxes"
    })
    boxes: number;

    @Column({
        type: "decimal", precision: 10, scale: 3,
        nullable: false,
        default: 0,
        name: "quantity"
    })
    quantity: number; 

    @Column({
        type: "decimal", precision: 10, scale: 2,
        nullable: false,
        name: "hon_count"
    })
    honCount: number;

    @Column({
        type: "decimal", precision: 10, scale: 3,
        nullable: false,
        name: "hon_quantity"
    })
    honQuantity: number; 

    @Column({
        type: "decimal", precision: 10, scale: 2,
        nullable: false,
        name: "rm_rate"
    })
    rmRate: number; 

    @Column({
        type: "decimal", precision: 10, scale: 2,
        nullable: false,
        name: "amount"
    })
    amount: number; 

    @Column('varchar',{
        name:'grade_range',
        length:30,
        nullable:true
    })
    gradeRange: string

    @Column( {
        type: "decimal", precision: 10, scale: 2,
        nullable: false,
        name: "grn_hon_count"
    })
    grnHonCount: number;

    @Column({
        type: "decimal", precision: 10, scale: 3,
        nullable: false,
        name: "grn_hon_quantity"
    })
    grnHonQuantity: number; 

    @Column({
        type: "decimal", precision: 10, scale: 2,
        nullable: false,
        name: "grn_rm_rate"
    })
    grnRmRate: number; 

    @Column('varchar',{
        name:'farmer',
        length : 50
    })
    farmer:string

    @Column('enum',{
        name:'harvest_type',
        enum :HarvestTypes
    })
    harvestType: HarvestTypes

    @Column('text',{
        name:'vehicle_num',
    })
    vehicleNum : string

    @Column("int", {
        name: "no_of_creates"
    })
    noOfCreates: number;

    @Column("datetime", {
        name: "harvest_date"
    })
    harvestDate: Date;

    @Column('enum',{
        name:'vehicle_type',
        enum :VehicleTypeEnum
    })
    vehicleType: VehicleTypeEnum

    @Column('varchar',{
        name:'supplier_type',
        length : 50
    })
    supplierType : string

    @Column( {
        type: "decimal", precision: 10, scale: 2,
        name: "reweighment_count"
    })
    reweighmentCount: number;

    @Column({
        type: "decimal", precision: 10, scale: 3,
        nullable: false,
        name: "reweighment_quantity"
    })
    reweighmentQuantity: number; 

    @Column('varchar',{
        name:'inv_num',
        length:50
    })
    invNum : string

    @Column({
        type: "decimal", precision: 10, scale: 2,
        nullable: false,
        name: "inv_amount"
    })
    invAmount: number; 

    @Column({
        type: "decimal", precision: 10, scale: 3,
        nullable: false,
        name: "inv_rate"
    })
    invRate: number; 

    @Column('varchar',{
        name : 'main_lot_no',
        length:50
    })
    mainLotNo : string

    @Column('int',{
        name : 'company_id'
    })
    companyId : number

    @Column('datetime',{
        name:'grn_date'
    })
    grnDate : Date

    @Column('datetime',{
        name:'plant_unloading_date'
    })
    plantUnloadingDate : Date

    @Column('varchar',{
        name:'city',
        length:50
    })
    city : string

    @Column('varchar',{
        name:'harvest_supervisor',
        length:50
    })
    harvestSupervisor : string

    @Column('varchar',{
        name:'intake_supervisor',
        length:50
    })
    intakeSupervisor : string

    @Column('boolean',{
        name:'is_vehicle_required',
    })
    isVehicleRequired : boolean

    @Column('int',{
        name:'ice_rate',
    })
    iceRate : number

    @Column("boolean", {
        nullable: false,
        default: true,
        name: "is_active"
    })
    isActive: boolean;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;


    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

    @Column("int", {
        nullable: true,
        name: "year",
    })
    year: number;

    @Column("int", {
        nullable: true,
        name: "grade_inv_id",
    })
    gradeInvId: number;

    @Column( {
        type: "decimal", precision: 10, scale: 2,
        nullable: false,
        name: "grn_count"
    })
    grnCount: number;

    @Column('decimal',{
        name:'commission',
        nullable:false,
        precision:10,scale:2
    })
    commission : number
}